<template>
	<div class="rejectApprovalWrap">
		<QueryHeader @queryData="handleQueryData"></QueryHeader>
		<div class="exportWrap">
			<el-button
				type="primary"
				icon="el-icon-download"
				@click="exportClick()"
				>导出
			</el-button>
		</div>
		<TableContent
			:tableData="tableData"
			left-action-btn="审批"
			right-action-btn="详情"
			@actionBtnClick="tableActionClick"
		></TableContent>
		<PageFooter
			:totalCount="totalCount"
			:pageIndex="pageIndex"
			:pageSize="pageSize"
			@pageChange="handlePageChange"
		></PageFooter>
	</div>
</template>

<script>
import QueryHeader from "./components/query";
import TableContent from "./components/table";
import PageFooter from "./components/page";
import {
	getWorkBenchRejectListApi,
	exportWorkBenchRejectListApi,
} from "../../../services/workbenchServices";
import { exportExcelService2 } from "../../../services/allContractServices";
import { getListRouteIdByType } from "../../approveComponents/approve";

export default {
	name: "rejectApproval",
	components: { QueryHeader, TableContent, PageFooter },
	data() {
		return {
			queryParams: {}, //查询条件
			pageIndex: 1,
			pageSize: 10,
			totalCount: 0,
			tableData: [],
		};
	},
	created() {
		this.queryData();
        this.bus.$on("headerActiveTabName", (item) => {
            if (item === "待审批列表") {
                this.queryData();
            }
        });
	},
	methods: {
		handleQueryData(params) {
			this.queryParams = params;
			this.pageIndex = 1;
			this.queryData();
		},
		handlePageChange(data) {
			this[data.type] = data.value;
			this.queryData();
		},
		queryData() {
			const params = {
				...this.queryParams,
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
			};
			getWorkBenchRejectListApi(params)
				.then((res) => {
					if (res.code == 10000000) {
						this.tableData = res.data || [];
						this.totalCount = res.total || 0;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch(() => {
					this.$message.error("网络请求失败");
				});
		},

		tableActionClick(data) {
			const { btnName, row } = data;
			this.bus.$emit("navMenuChange", {
				routeId: getListRouteIdByType(row.type,row.itemName),
				routeParam: {
					approveFlag: 'list',
					id: row.itemId,
				},
			});
		},
		exportClick() {
			exportWorkBenchRejectListApi(this.queryParams)
				.then((res) => {
					if (res.code == 10000000) {
						exportExcelService2(res.data).then((res1) => {
							this.$alert("导出成功", "提示", {
								confirmButtonText: "确定",
							});
						});
					} else if (res.code >= 20000000) {
						this.$alert(res.msg, "提示", {
							confirmButtonText: "确定",
						});
					} else {
						this.$alert("系统异常", "提示", {
							confirmButtonText: "确定",
						});
					}
				})
				.catch(() => {
					this.$message.error("网络请求失败");
				});
		},
	},
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.rejectApprovalWrap {
	height: 100%;
	background-color: white;
	padding: 16px;

	.exportWrap {
		text-align: right;
		margin: 16px 0;
	}
}
</style>
